import { ThemeUICSSObject } from '@apia/theme';
import defaultView from './defaultView';
import dropzone from './dropzone';
/* IMPORT HERE */

const uploader: ThemeUICSSObject = {
  defaultView,
  dropzone,
  tooltip: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,

    '.head': {
      textDecoration: 'underline',
    },
  },
  /* PREPEND HERE */
};

export default uploader;
